<template>
  <customModal :containerlg="true" @closeModal="closeModal">
    <template #title> KRI Details - {{ data?.ctqid }} </template>

    <template #body>
      <div class="modal-scroll-body">
        <!-- Loading -->
        <div
          class="d-flex justify-content-center align-items-center py-5"
          v-if="loading"
        >
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>

        <!-- No Data -->
        <div class="text-center py-5" v-else-if="!kriList.length">
          <p class="text-muted">No KRI data available</p>
        </div>

        <!-- Table Content -->
        <div v-else>
          
          <div class="table-responsive" style="overflow-x: auto;">
            <div class="ibox-title style_2 d-flex justify-content-between">
               <h5 class="m-0">{{ $t("navigations.keyRiskIndicators") }}</h5>
            <div class="position-relative align-self-center mt-0">
              <img
                src="@/assets/img/create.png"
                width="17"
                alt="Add Arm"
                style="cursor: pointer"
                @click="openManageKRIModal()"
              />
              <div class="tool-tip">{{ $t("navigations.addkri") }}</div>
            </div>
          </div>
            <table class="table table-striped table-bordered dataTables">
              <thead>
                <tr>
                  <th>KRI ID</th>
                  <th>Risk Indicator</th>
                  <th class="text-center">Edit</th>
                  <th class="text-center">View</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="item in kriList" :key="item.id">
                  <td>
                    <span>{{ item.kriId }}</span>
                  </td>
                  <td class="description-cell">
                    <div>
                      <span>{{
                        item.expanded
                          ? item.riskIndicator
                          : truncate(item.riskIndicator)
                      }}</span>
                      <a
                        v-if="
                          item.riskIndicator &&
                          item.riskIndicator.length > 120
                        "
                        class="more-less-link ms-1"
                        @click.stop="toggleExpand(item)"
                      >
                        {{ item.expanded ? "less" : "more" }}
                      </a>
                    </div>
                  </td>
                  <td class="text-center">
                    <i
                      class="fa fa-edit edit-delete"
                      @click="openManageKRIModal(item)"
                    >
                    </i>
                  </td>
                  <td class="text-center">
                    <i
                      class="fa fa-eye edit-delete"
                      @click="viewKriDetails(item)"
                    >
                    </i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Pagination -->
          <div class="row mx-0 mt-3" v-if="totalPages > 1">
            <div class="col-12 d-flex justify-content-end">
              <VPagination
                v-model="currentPage"
                :pages="totalPages"
                :range-size="1"
                active-color="#618bd7"
                @update:modelValue="loadPage"
              />
            </div>
          </div>
        </div>
      </div>
    </template>
  </customModal>
  <KriDetailsModal
    v-if="showKriDetailsModal"
    :data="selectedKriItem"
    @closeModal="closeKriDetailsModal"
  />
    <manageKRIModal
    v-if="openCreateRiskModal"
    :riskEditData="riskEditData"
    fromPage="kriInfoModal"
    @closeModal="closeKRIRiskModal"
    @reloadList="reloaddatagrid"
  />
</template>

<script src="./KriInfoModal.js"></script>

<style scoped>
.description-cell {
    max-width: 280px;
    white-space: normal;
    word-break: break-word;
}

.more-less-link {
  color: #5b9bd5 !important;
  cursor: pointer;
  font-size: 0.8rem;
  font-weight: 600;
  white-space: nowrap;
  user-select: none;
  text-decoration: none;
}

.more-less-link:hover {
  text-decoration: underline !important;
}

.badge {
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 0.85rem;
  font-weight: 500;
  display: inline-block;
  white-space: nowrap;
}

.badge-primary {
  background-color: #cce5ff;
  color: #004085;
}

.badge-success {
  background-color: #d4edda;
  color: #155724;
}

.badge-warning {
  background-color: #fff3cd;
  color: #856404;
}

.badge-info {
  background-color: #d1ecf1;
  color: #0c5460;
}

.badge-secondary {
  background-color: #e2e3e5;
  color: #383d41;
}

.badge-light {
  background-color: #f8f9fa;
  color: #212529;
  border: 1px solid #dee2e6;
}
.modal-scroll-body {
  padding: 10px 0;
  max-height: 60vh;
  overflow-y: auto;
}
.ibox-title{
  padding: 8px 15px 8px 15px !important;
  min-height: 34px;  
}
.position-relative .tool-tip{
  right: 18px;
  top: 0px;
}
</style>
